module.exports = __webpack_public_path__ + "static/media/Simon Landry.651887aa.png";